import type { Technique } from '../types';
import { GLITCH_PARAMS } from './params';
import { draw, elementCount, init, isComplete, step, type GlitchState } from './render';

export const glitch: Technique<GlitchState> = {
  id: 'glitch',
  name: 'Glitch',
  category: 'noise',
  description: 'Zerlegt den Text in versetzte Slices, spaltet die Farbkanäle und sortiert Pixel.',
  params: GLITCH_PARAMS,
  renderer: 'canvas2d',
  isAnimated: false,
  init,
  step,
  isComplete,
  draw,
  elementCount,
};
